import OnboardingStatusIndicator from './OnboardingStatusIndicator';

export default OnboardingStatusIndicator;
